const FitnessPost = [
    {
        id:1,
        img:"https://static.toiimg.com/thumb/msid-70555190,width-800,height-600,resizemode-75,imgsize-506827,pt-32,y_pad-40/70555190.jpg",
        title:"Running for weight loss",
        details:"Running is a great way to exercise and lose weight. It not just burns high number of calories (running at a normal pace for 30 minutes, on an average burns 259 calories.), but it also tones up your body. ",
        date:"Nov 12, 2022",
        type:"Fitness"
    },
    {
      id:2,
      img:"https://static.toiimg.com/thumb/msid-51478778,width-800,height-600,resizemode-75,imgsize-51683,pt-32,y_pad-40/51478778.jpg",
      title:"Simple ways to relax your body in office",
      details: " Setting small goals can help you achieve a healthy lifestyle. Here are simple ways to relax your body , increase physical movement while avoiding sitting down for long times",
      date:"Nov 12, 2022",
      type:"Fitness",
      num:1
  },
    {
      id:3,
      img:"https://images.indianexpress.com/2022/11/RamCharan-1200.jpg",
      title:"Ram Charan sets major fitness goals",
      details: "We love how the 'RRR' star has managed to enjoy his vacation while also ensuring he finds the means to stay physically active",
      date:"Nov 12, 2022",
      type:"Fitness"
    },
    {
      id:4,
      img:"https://images.indianexpress.com/2022/11/GettyImages-winter-workout-1200.jpg",
      title:"10 winter workouts that you must do",
      details: "Exercising in winters is particularly difficult, but you need to continue to stay active; here's how you can do that",
      date:"Nov 12, 2022",
      type:"Fitness"
      
    }
       
  ]
  export default FitnessPost;

export const FitnessFirstPost = [
{
  id:1,
  img:"https://static.toiimg.com/thumb/msid-70586756,width-800,height-600,resizemode-75,imgsize-722524,pt-32,y_pad-40/70586756.jpg",
  title:"Martial arts can develop strength",
  date:"Nov 13, 2022",
  type:"Fitness",
  num:"1"
}
]
export const FitnessTopPost = [
  {
    id:1,
    img:"https://static.toiimg.com/thumb/msid-51547836,width-800,height-600,resizemode-75,imgsize-127580,pt-32,y_pad-40/51547836.jpg",
    title:"Swim fitness and for fun",
    date:"Nov 13, 2022",
    type:"Fitness",
    num:"2"
  },
  {
    id:2,
    img:"https://static.toiimg.com/thumb/msid-57554234,width-800,height-600,resizemode-75,imgsize-25896,pt-32,y_pad-40/57554234.jpg",
    title:"Dancing is like dreaming",
    date:"Nov 13, 2022",
    type:"Fitness",
    num:"3"
  },
  {
    id:3,
    img:"https://static.toiimg.com/thumb/95278446.cms?width=680&height=512&imgsize=47414",
    title:"Too exercise short lifespan",
    date:"Nov 12, 2022",
    type:"Fitness",
    num:"4"
  },
  {
    id:4,
    img:"https://static.toiimg.com/thumb/77305572.cms?width=680&height=512&imgsize=989394",
    title:"Cycling for weight loss",
    date:"Nov 12, 2022",
    type:"Fitness",
    num:"5"
  }
  ]